
/**
 * Checks if an integration is available
 *
 * @param {Object} integration An integration
 * @return {Boolean} Whether the integration is available
 */
const isAvailable = ( integration ) => {
	return integration.is_available;
}

export default isAvailable;
